import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderWidgetComponent } from './header-widget.component';

@Component({
  template: `
    <div
      class="gridheader {{ header?.key }}"
      (mouseenter)="togglePopOver(true)"
      (mouseleave)="togglePopOver(false)"
    >
      <span class="label" [innerHTML]="header?.label"></span>
      <i
        class="fa fa-info-circle"
        *ngIf="header?.tooltipText[selectedGroup]"
      ></i>
      <div
        class="popover"
        [ngClass]="{ 'd-none': !showPopOver, right: isLast }"
        [innerHTML]="header?.tooltipText[selectedGroup]"
      ></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./grid-header.component.scss']
})
export class GridHeaderWithPopoverComponent extends HeaderWidgetComponent {
  showPopOver = false;

  togglePopOver(showPopOver: boolean) {
    this.showPopOver = showPopOver;
  }
}
